import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiSelect-selectMenu': {
      textOverflow: 'unset',
    },
  },
  bottomButtons: {
    marginTop: '3rem',
    marginBottom: '1rem',
  },
  dateSwitch: {
    marginTop: '25px',
    marginLeft: '1rem',
  },
  calendar: {
    padding: 0,
    paddingBottom: '25px',
    lineHeight: 0,
    display: 'flex',
    alignItems: 'flex-end',
  },
  stylePillButton: {
    background: '#948A8A',
    color: 'white',
    padding: '4px 14px',
    height: '32px',
    fontSize: '13px',
  },
  flexItemCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  notchedOutline: {
    // NOTE: the legend element is a child of the notchedOutline component
    '& legend': {
      maxWidth: '1000px',
    },
  },
  paddingRightBalance: {
    paddingRight: '20px',
  },
  marginTopField: {
    marginTop: '1.5rem',
  },
  marginBotomField: {
    marginBottom: '2rem',
  },
  marginTopCheckBox: {
    marginTop: '2rem',
  },
  flexLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap',
    overflow: 'none',
    textOverflow: 'ellipsis', /* text-overflow: clip; */
    marginTop: '-15px',
  },
  handleText: {
    whiteSpace: 'nowrap',
    overflow: 'none',
    textOverflow: 'ellipsis', /* text-overflow: clip; */
  },
  spanStyles: {
    marginLeft: '1rem',
    letterSpacing: '0.25rem',
    flex: 2,
  },
  spanFlex1: {
    flex: 1,
  },
  typographyStyles: {
    letterSpacing: '0.25rem',
  },
  opacityCalendarButton: {
    opacity: 0,
  },
  parentalFormDiv: {
    padding: '1rem 0',
    fontSize: '1.25rem',
  },
  linkCss: {
    color: '#0000EE',
    textDecoration: 'underline',
    fontWeight: 600,
    fontSize: '1rem',
  },
  ageTextStyle: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    paddingBottom: '27px!important',
  },
  inputBoxV2: {
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    height: '54px',
    overflow: 'hidden',
    justifyContent: 'space-between',
  },
  labelFillBefore: {
    textAlign: 'center',
    width: '9.5rem',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.primary.light,
    letterSpacing: '0.1rem',
    fontWeight: 400,
    fontSize: '1rem',
    flex: 1,
    fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
  },
  inputText: {
    padding: '14px',
    // paddingRight: '32px',
    flex: 2,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'none',
    textOverflow: 'ellipsis', /* text-overflow: clip; */
  },
  inputTextLeft: {
    padding: '14px',
    // paddingRight: '32px',
    flex: 2,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'none',
    textOverflow: 'ellipsis', /* text-overflow: clip; */
  },
  cssFontSize: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  cssSection: {
    display: 'grid',
    gridAutoRows: ' 1fr 1fr 1fr 1fr',
    alignItems: 'center',
    gap: '1rem',
    maxWidth: '1000px',
  },
  cssTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    letterSpacing: '2px',
  },
  disabledDropdown: {
    opacity: '0.6',
  },
  typeSubText: {
    fontSize: '1.2rem',
    fontWeight: 300,
    letterSpacing: '2px',
  },
  boxHeadQuater: {
    '& p': {
      marginTop: 0,
      marginBottom: 0,
      lineHeight: '1.5rem',
    },
  },
  textareaAutoSizeStyle: {
    resize: 'both',
    minHeight: '125px',
    overflow: 'hidden',
    margin: '0px',
    width: '100%',
    padding: '0px',
    position: 'relative',
    borderRadius: '4px',
    color: 'rgba(0, 0, 0, 0.87)',
    borderColor: 'transparent',
    outline: 'none',
    maxHeight: '75vh',
    fontSize: '1rem',
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    fontWeight: 400,
    lineHeight: '1.1876em',
    letterSpacing: '0.00938em',
    marginBottom: '1rem',
  },
}));

export default useStyles;
